import React from 'react';
import useStyles from '../../AdEditor/useStyles';
import sharedStyles from '../../AdList/useStyles';
import PropTypes from 'prop-types';
import { Dialog, Button, CircularProgress } from '@mui/material';

function GenericDialog({
  url,
  title,
  description,
  buttonText,
  buttonCallback,
  callbackLoading,
  isDialogOpen,
  setDialogOpen
}) {
  const classes = useStyles();
  const sharedClasses = sharedStyles();

  return (
    <Dialog
      open={isDialogOpen}
      onClose={() => setDialogOpen(false)}
      classes={{ paper: classes.dialog }}
    >
      <h4>{title}</h4>
      {description && <span>{description}</span>}
      <div className={classes.dialogButtonContainer}>
        <Button
          disableElevation
          className={sharedClasses.buttonSecondaryLight}
          onClick={() => setDialogOpen(false)}
          style={{ padding: '10px 30px' }}
        >
          Cancel
        </Button>
        <Button
          disableElevation
          className={
            buttonText === 'Clone ad' ? sharedClasses.buttonSecondary : sharedClasses.buttonRed
          }
          onClick={() => buttonCallback(url)}
          style={{ padding: '10px 30px' }}
        >
          {callbackLoading ? <CircularProgress size={20} color="inherit" /> : buttonText}
        </Button>
      </div>
    </Dialog>
  );
}

GenericDialog.propTypes = {
  url: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  buttonCallback: PropTypes.func,
  callbackLoading: PropTypes.bool.isRequired,
  isDialogOpen: PropTypes.bool.isRequired,
  setDialogOpen: PropTypes.func.isRequired,
  buttonTextColor: PropTypes.string,
  isContinueButton: PropTypes.bool
};

export default GenericDialog;
